/**
 * Agrupa por DIA, como a Agenda: "Hoje", "Ontem", depois a data por extenso.
 * Lista corrida de 5 mil itens não diz o que é de hoje — o cabeçalho do dia
 * diz. Recebe itens com `last_activity_at` em segundos (formato da API).
 */
const inicioDoDia = d => new Date(d.getFullYear(), d.getMonth(), d.getDate());

export const chaveDoDia = (segundos, agora = new Date()) => {
  const dia = inicioDoDia(new Date(segundos * 1000));
  const hoje = inicioDoDia(agora);
  const diff = Math.round((hoje - dia) / 86400000);
  if (diff === 0) return 'hoje';
  if (diff === 1) return 'ontem';
  // Data LOCAL: `toISOString` é UTC e, depois das 21h em Brasília, jogaria
  // o item no dia seguinte.
  const mm = String(dia.getMonth() + 1).padStart(2, '0');
  const dd = String(dia.getDate()).padStart(2, '0');
  return `${dia.getFullYear()}-${mm}-${dd}`;
};

export const rotuloDoDia = (chave, { hoje, ontem }, locale = 'pt-BR') => {
  if (chave === 'hoje') return hoje;
  if (chave === 'ontem') return ontem;
  const [a, m, d] = chave.split('-').map(Number);
  // O app guarda o idioma como `pt_BR`; o Intl só aceita `pt-BR` e LANÇA
  // erro com o sublinhado — o que derrubava a lista inteira (medido).
  const idioma = String(locale || 'pt-BR').replace('_', '-');
  const texto = new Date(a, m - 1, d).toLocaleDateString(idioma, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
  return texto.charAt(0).toUpperCase() + texto.slice(1);
};

export const agruparPorDia = (itens, agora = new Date()) => {
  const grupos = [];
  itens.forEach(item => {
    const chave = chaveDoDia(item.last_activity_at, agora);
    const ultimo = grupos[grupos.length - 1];
    if (ultimo && ultimo.chave === chave) ultimo.itens.push(item);
    else grupos.push({ chave, itens: [item] });
  });
  return grupos;
};
